import React, { useMemo, useState } from 'react';
// @ts-ignore
import styles from './PredefinedPhrasesDiscourseSetupItem.module.scss';
import RemoveButton from '../../../../Components/Button/RemoveButton';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import PredefinedPhrasesDiscoursePhraseFormModal from './PredefinedPhrasesDiscoursePhraseFormModal';
import { PredefineDiscoursePhrase } from './PredefinedPhrasesDiscourseSetup';
import apiClient from '../../../../Services/ApiClient';
import { getLabel } from '../../Services/discrousePredifinedPhrase.service';
import useRestApiClient from '../../../Base/Hooks/useRestApiClient';

interface Props {
	item: PredefineDiscoursePhrase;
	onEdit: () => void;
	onDelete: () => void;
}

const PredefinedPhrasesDiscourseSetupItem: React.FC<Props> = ({
	item,
	onEdit,
	onDelete,
}) => {
	const { processResult } = useRestApiClient();
	const [isEditOpen, setIsEditOpen] = useState(false);

	const handleOnEdit = () => {
		setIsEditOpen(false);
		onEdit();
	};

	const handleDeletePhrase = async () => {
		const result = await apiClient.delete(`/document/${item.id}`);
		processResult(result, () => {
			onDelete();
		});
	};

	const label: string | undefined = useMemo(() => {
		return getLabel(item);
	}, [item]);

	return (
		<>
			<div className={styles.wrapper}>
				{label && <div>{label}</div>}
				<div className={styles.controls}>
					<LinkButton
						title='component.predefinedPhrasesListItem.edit'
						theme={Theme.BLUE}
						onClick={() => setIsEditOpen(true)}
					/>
					<RemoveButton onClick={handleDeletePhrase} firstUpper />
				</div>
			</div>
			{isEditOpen && (
				<PredefinedPhrasesDiscoursePhraseFormModal
					isOpen
					onClose={() => setIsEditOpen(false)}
					onSuccess={handleOnEdit}
					defaultValue={item}
				/>
			)}
		</>
	);
};

export default PredefinedPhrasesDiscourseSetupItem;
